var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 55.5C43.1878 55.5 55.5 43.1878 55.5 28C55.5 12.8122 43.1878 0.5 28 0.5C12.8122 0.5 0.5 12.8122 0.5 28C0.5 43.1878 12.8122 55.5 28 55.5ZM40.1647 15.8359C40.6118 16.2838 40.6118 17.0099 40.1647 17.4578L29.6191 28.0211L40.1225 38.5422C40.5696 38.9901 40.5696 39.7162 40.1225 40.1641C39.6754 40.612 38.9505 40.612 38.5034 40.1641L28 29.643L17.4966 40.1641C17.0495 40.6119 16.3246 40.6119 15.8775 40.1641C15.4303 39.7162 15.4303 38.9901 15.8775 38.5422L26.3808 28.0211L15.8353 17.4578C15.3882 17.0099 15.3882 16.2838 15.8353 15.8359C16.2825 15.3881 17.0074 15.3881 17.4545 15.8359L28 26.3992L38.5455 15.8359C38.9926 15.388 39.7175 15.388 40.1647 15.8359Z",
    fill: "#B01BAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b6b5e836ba0a82ddfd319bc7e7b722e7.svg";
export { ForwardRef as ReactComponent };